import { Card, useTheme } from '@mui/material'
import { memo } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import customConfig from 'customConfig'
import {
  NUMBER_OF_TX_PER_PAGE,
  TRANSACTION_STATUS_LABEL
} from '../../constants/transactions'
import { formatTransaction } from '../../util/transactionRow.helpers'
import { LoadingScreen } from '../shared/loading-screen'
import CustomDataTable from '../shared/customDataTable/CustomDataTable'
import { TableNoData, TableSkeleton } from '../shared/table'
import TransactionRow from './TransactionRow'

const TransactionsTable = ({
  t,
  sx,
  loading,
  tableHeaders,
  transactions,
  tokenProfile,
  accountProfile,
  onShowFuturePointsInfo,
  scrollDataProps,
  ...other
}) => {
  const theme = useTheme()
  return (
    <Card sx={sx} {...other}>
      {loading ? (
        <CustomDataTable tableHeaders={tableHeaders}>
          <TableSkeleton
            rowCount={NUMBER_OF_TX_PER_PAGE}
            cellCount={tableHeaders.length}
            sx={{ height: 69 }}
          />
        </CustomDataTable>
      ) : !transactions.length && !loading ? (
        <CustomDataTable tableHeaders={tableHeaders}>
          <TableNoData
            icon={customConfig.transactionsIcon}
            description={t(customConfig.noTransactionsLabel)}
          />
        </CustomDataTable>
      ) : (
        <InfiniteScroll
          dataLength={transactions.length}
          loader={<LoadingScreen sx={{ my: { xs: 2, md: 3 } }} />}
          {...scrollDataProps}
        >
          <CustomDataTable tableHeaders={tableHeaders}>
            {transactions.map((transaction, index) => {
              const { status, isNft, ...restProps } = formatTransaction(
                transaction,
                t,
                tokenProfile,
                accountProfile.authId
              )
              const isFutureReward = status === TRANSACTION_STATUS_LABEL.FUTURE
              return (
                <TransactionRow
                  t={t}
                  key={index}
                  theme={theme}
                  onClick={() =>
                    isFutureReward ? onShowFuturePointsInfo(isNft) : null
                  }
                  anchor={isFutureReward}
                  status={status}
                  {...restProps}
                />
              )
            })}
          </CustomDataTable>
        </InfiniteScroll>
      )}
    </Card>
  )
}

export default memo(TransactionsTable)
